import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminComponent } from './theme/layout/admin/admin.component';
import {AuthComponent} from './theme/layout/auth/auth.component';
import { AuthGuard } from './guards/auth.guard';
import { PermissionGuard } from './guards/permission.guard';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: AuthComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('./features/pages/authentication/authentication.module').then(module => module.AuthenticationModule)
      },
      {
        path: 'maintenance',
        loadChildren: () => import('./features/pages/maintenance/maintenance.module').then(module => module.MaintenanceModule)
      }
    ]
  },
  {
    path: 'dashboard',
    component: AdminComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('./features/dashboard/dashboard.module').then(module => module.DashboardModule)
      }
    ]
  },
  {
    path: 'users',
    component: AdminComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('./features/pages/users/users.module').then(module => module.UsersModule)
      }
    ]
  },
  {
    path: 'employees',
    component: AdminComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('./features/pages/users/users.module').then(module => module.UsersModule)
      }
    ]
  },
  {
    path: 'customers',
    component: AdminComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('./features/pages/customers/customers.module').then(module => module.CustomersModule)
      }
    ]
  },
  {
    path: 'customer-groups',
    component: AdminComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('./features/pages/customer-group/customer-group.module').then(module => module.CustomerGroupModule)
      }
    ]
  },
  {
    path: 'machines',
    component: AdminComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('./features/pages/machines/machines.module').then(module => module.MachinesModule)
      }
    ]
  },
  {
    path: 'machine-assignment',
    component: AdminComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('./features/pages/machines/machine-assignment/machine-assignment.module').then(module => module.MachineAssignmentModule)
      }
    ]
  },
  {
    path: 'products',
    component: AdminComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('./features/pages/products/products.module').then(module => module.ProductsModule)
      }
    ]
  },
  {
    path: 'attendance',
    component: AdminComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('./features/pages/attendance/attendance.module').then(module => module.AttendanceModule)
      }
    ]
  },
  {
    path: 'stocks',
    component: AdminComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('./features/pages/stocks/stocks.module').then(module => module.StocksModule)
      }
    ]
  },
  {
    path: 'file-management',
    component: AdminComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('./features/pages/file-upload/file-upload.module').then(module => module.FileUploadModule)
      }
    ]
  },
  {
    path: 'assignments',
    component: AdminComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('./features/pages/assignments/assignments.module').then(module => module.AssignmentsModule)
      }
    ]
  },
  {
    path: 'vendors',
    component: AdminComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('./features/pages/vendors/vendors.module').then(module => module.VendorsModule)
      }
    ]
  },
  {
    path: 'help',
    component: AdminComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('./features/pages/help-workflow/help-workflow.module').then(module => module.HelpWorkflowModule)
      }
    ]
  },
  {
    path: 'deleted-records',
    component: AdminComponent,
    canActivate: [AuthGuard, PermissionGuard],
    data: { requiredPrivileges: ['settings.backup', 'settings.restore'] },
    children: [
      {
        path: '',
        loadChildren: () => import('./features/pages/backup/backup.module').then(module => module.BackupModule)
      }
    ]
  },
  {
    path: 'logout',
    redirectTo: '/',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
